













import Vue from 'vue'
import { mapState, mapGetters, mapActions } from 'vuex'
import SurfaceHeader from 'vuecomponents/surface_header.vue'
import SurfacePosts from 'vuecomponents/surface_posts.vue'
import DoubleClickToPostMixin from 'vuemixins/double_click_to_post_mixin'
import PasteToPostMixin from 'vuemixins/paste_to_post_mixin'
import DropToPostMixin from 'vuemixins/drop_to_post_mixin'
import loadMapApi from 'bits/map_api_loader'
import { $ } from 'bits/jquery'
import { listenScrollHeader, unlistenScrollHeader } from 'bits/header_scrolling'
import { subscribeUpdateBodySizeCss, unsubscribeUpdateBodySizeCss } from 'bits/body_sizing'
import { RootState } from 'surface/xstore/types'

export default Vue.extend({
  components: {
    SurfaceHeader,
    SurfacePosts,
    SurfaceContainerGrid: () => import('vuecomponents/surface_container_grid.vue'),
    SurfaceContainerMap: () => import('vuecomponents/surface_container_map.vue'),
    SurfaceContainerTable: () => import('vuecomponents/surface_container_table.vue'),
  },
  mixins: [DoubleClickToPostMixin, PasteToPostMixin, DropToPostMixin],
  data () {
    return {
      isMapApiLoaded: false,
    }
  },
  computed: {
    ...mapGetters('post', ['postBeingEditedCid']),
    ...mapGetters('snackbars', ['xSnackbar']),
    ...mapGetters([
      'xHeader',
      'isPostable',
      'isReadOnly',
      'format',
      'isMap',
      'isGrid',
      'isCanvas',
      'isTable',
    ]),
    ...mapState({
      googleApiKeyForMap: (state: RootState) => state.constants.googleApiKeyForMap,
    }),
  },
  watch: {
    isPostable (newValue) {
      if (newValue) {
        this.enableNewPostHandlers()
      } else {
        this.disableNewPostHandlers()
      }
    },
    format (newValue, oldValue) {
      if (newValue !== oldValue) {
        // Allow native bridge messages to flush before reloading
        this.$nextTick(() => window.location.reload())
      }
    },
  },
  async mounted () {
    this.refresh()
    // Bring new post into view
    this.autoRefreshOnVisibilityChange()
    if (this.isMap) {
      await loadMapApi(this.googleApiKeyForMap)
      this.isMapApiLoaded = true
    } else {
      this.$nextTick(() => {
        if (this.isPostable) {
          this.enableNewPostHandlers()
        }
      })
    }
    if (this.isCanvas && this.xHeader) {
      listenScrollHeader(
        this.$refs.wallContainer as HTMLElement,
        (this.$refs.surfaceHeader as Vue).$el as HTMLElement
      )
    }
    // Ensure that export as image captures all posts
    if (this.isReadOnly && (this.isGrid || this.isCanvas)) {
      const hookToAllStoreChanges = (store => store.subscribe.bind(store))(this.$store)
      const events = ['load', 'beethoven-load', 'error', 'beethoven-error', hookToAllStoreChanges]
      const extraMarginInPx = 200
      subscribeUpdateBodySizeCss('wish', events, extraMarginInPx)
    }
  },
  beforeDestroy () {
    this.disableNewPostHandlers()
    unlistenScrollHeader()
    unsubscribeUpdateBodySizeCss()
  },
  methods: {
    ...mapActions(['refresh']),
    enableNewPostHandlers () {
      if (this.isGrid || this.isTable || this.isMap) return
      this.enableDoubleClickToPost(this.$el, this.$refs.wishList)
      this.enablePasteToPost()
      this.enableDropToPost(this.$el)
    },
    disableNewPostHandlers () {
      this.disableDoubleClickToPost(this.$el)
      this.disablePasteToPost()
      this.disableDropToPost(this.$el)
    },
    autoRefreshOnVisibilityChange () {
      if (this.autoRefreshEnabled) return
      $(document).on('visibilitychange', () => {
        if (document.visibilityState === 'visible') {
          this.refresh()
        }
      })
      // TODO remove this eventually. Others depend on it
      $(document).on('padlet:refresh', this.refresh)
      this.autoRefreshEnabled = true
    },
  },
})
